import { User } from '../types/user.type';
import { UserRole, UserRoles } from '../types/user-role.type';
import { CREATABLE_USER_ROLES } from '../types/dtos/admin-create-user.dto';

type RoleTarget = Pick<User, 'id' | 'role'>;

type AssignableRolesParams = {
  actorRole: UserRole;
  actorId: string;
  target: RoleTarget;
};

type AssignableRoles = {
  roles: UserRole[];
  isLocked: boolean;
};

const STAFF_ROLES: readonly UserRole[] = [UserRoles.ADMIN, UserRoles.SUPER_ADMIN];

const CREATABLE_ROLES: readonly UserRole[] = CREATABLE_USER_ROLES;

export const isStaffAccountProtected = ({ actorRole, target }: { actorRole: UserRole; target: RoleTarget }): boolean =>
  actorRole !== UserRoles.SUPER_ADMIN && STAFF_ROLES.indexOf(target.role) !== -1;

export const getAssignableRoles = ({ actorRole, actorId, target }: AssignableRolesParams): AssignableRoles => {
  const isSuperAdmin = actorRole === UserRoles.SUPER_ADMIN;

  return {
    roles: Object.values(UserRoles).filter(
      (role) => isSuperAdmin || CREATABLE_ROLES.indexOf(role) !== -1 || role === target.role
    ),
    isLocked: actorId === target.id || isStaffAccountProtected({ actorRole, target }),
  };
};
